import React from 'react';
import { dispatch } from '@rematch/core';
import { Portal, Image, List, Card, Button, Icon } from 'semantic-ui-react'
import { Container, Draggable } from 'react-smooth-dnd'
import TreeView from '@zippytech/react-toolkit/TreeView'
import '@zippytech/react-toolkit/TreeView/index.css';
import EllipsisTooltip from './../../../common/EllipsisTooltip';
import contentImage from '../../../../images/svg/noti-content.svg'
import ContentDetail from '../../contentManager/Drive/Modal/ContentDetail'
import convertIcon from '../../../../helpers/convert-Icon';
import numberFormatter from '../../../../helpers/numberFormatter';
import LabelWithCount from '../../../common/LabelWithCount';

let contentComponents = [];
let getDataContent = [];
class ContentTreeMenu extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false,
        }
    }

    handleOpen = async (e, data) => {
        this.setState({ open: true, top: e.clientY - 60, left: e.clientX + 20 })
        await dispatch.content.setSingleContent(data.item)
    }

    openDialog = (isOpen) => {
        this.handleClose()
        this.setState({ isOpen: isOpen })
    }

    handleClose = () => {
        this.setState({ open: false })
    }

    componentWillReceiveProps(newProps) {
        if (this.props.selectedContent !== newProps.selectedContent) {
            this.setState({ content: newProps.selectedContent })
        }
    }

    viewContentURL = (e, data) => {
        let redirectUrl = data.contentpath.indexOf('://') === -1 ? 'http://' + data.contentpath : data.contentpath
        window.open(redirectUrl, '_blank');
    }

    getContentList() {
        getDataContent = []
        this.props.publishedContent &&
            this.props.publishedContent.data &&
            this.props.publishedContent.data.map(function (item, i) {
                getDataContent.push({
                    id: item._id,
                    name: item.name,
                    scope: item.scope,
                    type: item.type,
                    contentpath: item.contentpath,
                    draggableType: 'content'
                });
            })
        this.createContentTree();
    }
    getElementToDrag = (i, index) => {
        return getDataContent[i]
    }



    createContentTree = () => {
        let contentArray = [];
        if (getDataContent && getDataContent.length !== 0) {
            getDataContent.map((p, i) => {
                contentArray.push({
                    label:
                        <Container
                            key={i}
                            onDragStart={this.onDragStartContent}
                            onDragEnd={this.onContentDrop}
                            groupName="Content"
                            behaviour="copy"
                            getChildPayload={index => this.getElementToDrag(i, index)} >

                            <Portal
                                closeOnPortalMouseLeave
                                closeOnTriggerMouseLeave
                                openOnTriggerMouseEnter
                                mouseEnterDelay={1500}
                                mouseLeaveDelay={100}
                                trigger={<Draggable >
                                    <div className="draggable-item browser-search-draggable"
                                        style={{
                                            textOverflow: "ellipsis",
                                            overflow: "hidden"
                                        }}>
                                        <Icon name={convertIcon(p.type)} />{p.name}
                                    </div>
                                </Draggable>}
                                item={p}
                                onOpen={this.handleOpen}
                                onClose={this.handleClose}
                            >
                                <Card
                                    style={{
                                        left: this.state.left,
                                        position: 'fixed',
                                        top: this.state.top,
                                        zIndex: 100,
                                        width: "360px",
                                        background: 'white',
                                    }}
                                >
                                    <Card.Content style={{ padding: "7px 10px" }} >
                                        <List >
                                            <List.Item>
                                                <List.Content floated='right'>
                                                    <span className="f_10">Publishing Level</span><br />
                                                    <b className="clr-green">{this.props.selectedContent.scope === "Public" ? "Public Library" : "Workspace Library"}</b>
                                                </List.Content>
                                                <Image
                                                    avatar
                                                    src={this.props.selectedContent.author && this.props.selectedContent.author.profilePic}
                                                />
                                                <List.Content>
                                                    <span className="f_10">Uploaded by</span>
                                                    <List.Header>
                                                        {this.props.selectedContent.author && this.props.selectedContent.author.firstName}&nbsp;
                                                        {this.props.selectedContent.author && this.props.selectedContent.author.lastName}
                                                    </List.Header>
                                                </List.Content>
                                            </List.Item>
                                        </List>
                                    </Card.Content>
                                    <Card.Content style={{ padding: "7px 10px" }} >

                                        <List >
                                            <List.Item>
                                                <Image style={{
                                                    height: "14px", float: "left",
                                                    width: '20px',
                                                    margin: "0 7px 0 0",
                                                    width: '20px'
                                                }} src={contentImage} />
                                                <List.Content style={{
                                                    margin: "0 0 0 5px", float: 'left',
                                                    width: 'calc(100% - 35px)'
                                                }}>
                                                    <span className="f_10">Content Name</span>
                                                    <List.Header>{p.name}</List.Header>
                                                </List.Content>
                                            </List.Item>
                                        </List>
                                    </Card.Content>
                                    <Card.Content style={{ padding: "7px 10px" }} extra>
                                        <Button
                                            size='mini'
                                            className="button-info"
                                            icon={convertIcon(this.props.selectedContent.type)}
                                            content={`${this.props.selectedContent.type}`}
                                            style={{ padding: "5px 10px" }}
                                            onClick={(e) => this.viewContentURL(e, this.props.selectedContent)} />
                                        <Button
                                            size='tiny'
                                            className="float-right button-submit"
                                            content="Details"
                                            style={{ padding: "5px 10px" }}
                                            onClick={() => this.openDialog(true)} />
                                    </Card.Content>
                                </Card>
                            </Portal>
                        </Container>
                });
            })
            if (this.props.publishedContent && this.props.publishedContent.total > 10 && this.props.publishedContent.total !== getDataContent.length) {
                contentArray.push({
                    label: <Button
                        className="button-info"
                        size='tiny'
                        style={{ width: "calc(100% - 5px)" }}
                        onClick={() => this.props.setDataAsPerCategory(null, null, getDataContent.length + 10, "content")}>Load More</Button>
                });
            }

        } else {
            contentArray.push({
                label: <span className="clr-gray">No Content To Display</span>
            })
        }

        let cnt = {
            label: <LabelWithCount labelClass="bg-blue" label="Content" count={this.props.publishedContent && this.props.publishedContent.total !== 0 ? this.props.publishedContent.total : 0} />,
            nodes: contentArray
        }

        contentComponents = []
        contentComponents.push(cnt)
    }

    onDragStartContent = ({ payload }) => {
        if (payload !== null && payload !== undefined && payload !== 'undefined') {
            dispatch.lifeCycle.setIsDragableFlag('content')
        }
    }
    onContentDrop = ({ payload }) => {
        dispatch.lifeCycle.setIsDragableFlag(null);
    }


    render() {
        this.getContentList();

        return (
            <div>
                <TreeView
                    className="activityList heightAuto browserPane noHoverEffect"
                    defaultCollapsedDepth={0}
                    dataSource={contentComponents}
                    enableHoverStyle={false}
                    enableKeyboardNavigation={false}

                />
                <ContentDetail
                    isOpen={this.state.isOpen}
                    content={this.state.content}
                    openDialog={this.openDialog}
                />
            </div>

        );
    }
}
export default ContentTreeMenu;